export default function validator() {
  return import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "validatorjs" */
    'validatorjs'
  );
}